<template>
    <b-modal
        title="Add Screening Results"
        :visible="true"
        centered
        header-bg-variant="success"
        header-text-variant="light"
        @hide="closeModal"
        @ok="addOldTraffickingScreening"
    >
    <template #modal-header-close>
      <h4>X</h4>
    </template>
        <p>
            <b>
            Please select from the drop-down menu below the screening results for the Louisiana Indicator Tool for Child & Youth Sex Trafficking.
            </b>
        </p>
        <b-form-group
            label="Screening Results"
            label-align-sm="left"
            label-for="screening-results">
            <b-form-select
              id="screening-results"
              v-validate="'required'"
              data-vv-name="conclusion"
              data-vv-as="Screening Name"
              :options="conclusionOptions"
              placeholder="Please select an option"
              v-model="screening.conclusion">
            </b-form-select>
            <span v-show="inputValidationErrors.has('conclusion')" class="text-info">{{ inputValidationErrors.first('conclusion') }}</span>
        </b-form-group>
        <p>
            <b>
                If available, upload PDF copy of the Louisiana Indicator Tool for Child & Youth Sex Trafficking by clicking on the button below.
            </b>
        </p>
        <label for="file-upload" class="custom-file-upload">
            Upload PDF
        </label>
        <span>{{ screening.fileName }}</span>
        <input :disabled="isLoading" type="file" id="file-upload" @change="onFileUpload" />
        <p>
            <b>Comments</b>
        </p>
        <b-form-textarea rows="10" class="mt-3" placeholder="Enter Comments" name="comments" v-model="screening.comments"></b-form-textarea>
        <b-alert
            fade
            :show="createOldTraffickingScreeningError || createOldTraffickingScreeningSuccess"
            :variant="createOldTraffickingScreeningError ? 'danger' : 'success'"
        >
            <span v-html="apiResponseMessage"></span>
        </b-alert>
        <template #modal-footer>
            <b-button
                variant="secondary"
                size="sm"
                :disabled="isLoading"
                @click="closeModal"
            >
                Cancel
            </b-button>
            <b-button
                variant="primary"
                size="sm"
                style="width: 60px"
                :disabled="isLoading"
                @click="addOldTraffickingScreening"
            >
                <i v-if="isLoading" class="fa fa-spinner"></i>
                <span v-else>
                    Submit
                </span>
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { oldTraffickingScreening as OldTraffickingScreeningModel } from '@/api/models'
import {
    OLD_TRAFFICKING_SCREENING_CONCLUSION_ENUM
} from '@/helpers/enums.js'

export default {
    name: 'AddOldTraffickingScreeningModal',

    inject: ['$validator'],

    props: {
        personId: {
            type: Number,
            default: 0
        },
        showModal: Boolean
    },

    data () {
        return {
            screening: Object.assign({}, OldTraffickingScreeningModel),
            chosenFileName: '',
            isLoading: false
        }
    },

    computed: {
        ...mapGetters({
            createOldTraffickingScreeningError: 'getCreateOldTraffickingScreeningError',
            createOldTraffickingScreeningSuccess: 'getCreateOldTraffickingScreeningSuccess'
        }),

        conclusionOptions () {
            return [
                {
                    text: 'Please select an option',
                    value: ''
                },
                {
                    text: 'Not Enough Information',
                    value: OLD_TRAFFICKING_SCREENING_CONCLUSION_ENUM.NOT_ENOUGH_INFO
                },
                {
                    text: 'Concern',
                    value: OLD_TRAFFICKING_SCREENING_CONCLUSION_ENUM.CONCERN
                },
                {
                    text: 'Indicated',
                    value: OLD_TRAFFICKING_SCREENING_CONCLUSION_ENUM.INDICATED
                }
            ]
        },

        apiResponseMessage () {
            const message = this.createOldTraffickingScreeningSuccess
                ? 'Success'
                : 'An error occurred. Please try again.'

            return `<p>${message}</p>`
        }
    },

    watch: {
        createOldTraffickingScreeningSuccess (value) {
            if (value) {
                this.closeModalTimeout = setTimeout(() => {
                    this.closeModal()
                }, 500)
            }
        },

        createOldTraffickingScreeningError (value) {
            if (value) {
                this.closeModalTimeout = setTimeout(() => {
                    this.closeModal()
                }, 500)
            }
        }
    },

    beforeDestroy () {
        clearTimeout(this.closeModalTimeout)
        this.screening = Object.assign({}, OldTraffickingScreeningModel)
    },

    methods: {
        closeModal () {
            this.$emit('close')
        },

        addOldTraffickingScreening () {
            this.isLoading = true
            this.screening.person = this.personId
            this.$validator.validate().then((isValid) => {
                if (!isValid) {
                    return
                }

                this.$store.dispatch('createOldTraffickingScreening', this.screening)
            })
        },

        onFileUpload (e) {
            if (!e.target.files.length) {
                return
            }

            const fileData = e.target.files[0]

            this.screening.fileName = fileData.name
            this.screening.fileData = fileData
        }
    }
}
</script>

<style lang="scss" scoped>
input[type="file"] {
    position: absolute;
    left: -99999rem;
}

.custom-file-upload {
    display: inline-block;
    font-weight: 400;
    color: #fff;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    background-color: #4dbd74;
    border: 1px solid #4dbd74;
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0;
    -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
}

.fa-spinner {
    animation: spin 5000ms infinite linear;
}

@keyframes spin {
    from {
        transform:rotate(0deg);
    }
    to {
        transform:rotate(360deg);
    }
}
</style>


// WEBPACK FOOTER //
// src/views/t1/AddOldTraffickingScreeningModal.vue